module.exports = __webpack_public_path__ + "img/round-stories.0ee50cda.png";